module.exports = __webpack_public_path__ + "static/seo-anuel-afab4538d9b2a38a3efd25afb21e501a.png";